//用于新开iframe时，向父iframe获取字号大小

// import {UserInfoService} from "../services/main/userInfoService"



    let parentDoc = window.parent.document;
    let fontSize = $(parentDoc).find('html').css('font-size') || 14;
    // let fontSize = wordNumber + 'px';
    //为解决网页缩小到一定比例，字体变为15px,必填标识缺失问题
    let style=$(parentDoc).find('html').attr('style');
    if (!_.isUndefined(style)) {
        //解决子表字体比父表大一点的问题
        let arry = style.split(';');
        let font;
        for (let i in arry){
            if (arry[i].includes('font-size')) {
                font = arry[i].split(':')[1]
            }
        }
        font = font.replace(/\s+/g,"");//替换空格
        fontSize = font;
    }
    let selfDoc = window.document;
    $(selfDoc).find('html').css('font-size',fontSize);
    $(parentDoc).find('html').attr('fontsize',fontSize);
    $(selfDoc).find('html').attr('fontsize',fontSize);
    if(window.config){
        window.config.fontsize = parseInt(fontSize);
    }else{
        window.config = {};
        window.config.fontsize = parseInt(fontSize);
    }

    // $(window.document).find('body').addClass(`icon-type-`+ parseInt(wordNumber));
// }
// fontStyle ();



// WEBPACK FOOTER //
// app/lib/fontsize.js